export enum Card {
  APPLICATION = 'application',
  FHA = 'fha',
  HARVEST = 'harvest',
  PLANTING = 'planting',
  PRESCRIPTIONS = 'prescriptions',
  WEATHER = 'weather',
}
